import useGetContent from './useGetContent'

export default useGetContent
